/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventfieldcapacity2Inputs */

const en_eventfieldcapacity2 = /** @type {(inputs: Eventfieldcapacity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacity`)
};

const de_eventfieldcapacity2 = /** @type {(inputs: Eventfieldcapacity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapazität`)
};

/**
* | output |
* | --- |
* | "Capacity" |
*
* @param {Eventfieldcapacity2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventfieldcapacity2 = /** @type {((inputs?: Eventfieldcapacity2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventfieldcapacity2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventfieldcapacity2(inputs)
	return de_eventfieldcapacity2(inputs)
});
export { eventfieldcapacity2 as "eventFieldCapacity" }